import React from "react"
import { Tabs, Tab } from "material-ui"
import strings from "../../localization/strings"
import AccountManagerDetailsClientTab from "./tabs/AccountManagerDetailsClientTab"
import AccountManagerDetailsSystemTab from "./tabs/AccountManagerDetailsSystemTab"
import AccountManagerDetailsMarketingFunnelTab from "./tabs/AccountManagerDetailsMarketingFunnelTab"
import AccountManagerDetailsUsersTab from "./tabs/AccountManagerDetailsUsersTab"
import * as permissionHelper from "../../helpers/permissionHelper"
import AuthenticationStore from "../../stores/AuthenticationStore"
import * as api from "../../api"
import { IAccountManagerDocument } from "../../models"

interface IState {
    activeTab: string
    accountManagerName: string
}

interface IProps {
    accountManagerId: string
}

export default class AccountManagerDetails extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            activeTab: "clients",
            accountManagerName: "",
        }
    }

    componentDidMount(): void {
        this.getAccountManager()
        if (!permissionHelper.hasAccountManagerPermission(AuthenticationStore.AccountManagerUserPermissions.Clients.ViewClients)) {
            const activeTab = permissionHelper.hasAccountManagerPermission(AuthenticationStore.AccountManagerUserPermissions.Account.ViewAacountManagerUsersTab) ? "accountManagerUsers" : "plgSetup"
            this.setState({ activeTab })
        }
    }

    getAccountManager() {
        const loggedInAMUser = AuthenticationStore.getLoggedInAccountManagerUser()
        if (loggedInAMUser.ViewAllAccountManagers && loggedInAMUser.AccountManagerIds === null) {
            this.setState({ accountManagerName: "Findd System" })
        } else {
            api.getAccountManagerById(this.props.accountManagerId).then(res => {
                this.setState({ accountManagerName: (res.data as IAccountManagerDocument).Name })
            })
        } 
    }

    render() {
        return (
            <div>
                <h2 style={{ padding: "20px 5px 0px 30px", marginBottom: -1 }}>{this.state.accountManagerName}</h2>
                <Tabs
                    style={{ marginTop: 10 }}
                    value={this.state.activeTab}
                    onChange={activeTab => this.setState({ activeTab })}
                >
                    {permissionHelper.hasAccountManagerPermission(AuthenticationStore.AccountManagerUserPermissions.Clients.ViewClients) &&
                        <Tab label={strings.Clients} value="clients">
                            {this.state.activeTab === "clients" &&
                                <AccountManagerDetailsClientTab accountManagerId={this.props.accountManagerId} />
                            }
                    </Tab>
                    }
                    {permissionHelper.hasAccountManagerPermission(AuthenticationStore.AccountManagerUserPermissions.Account.ViewAacountManagerUsersTab) &&
                        <Tab label={strings.Account_Manager_Users} value="accountManagerUsers">
                            {this.state.activeTab === "accountManagerUsers" &&
                                <AccountManagerDetailsUsersTab accountManagerId={this.props.accountManagerId} />
                            }
                        </Tab>
                    }
                    <Tab label={strings.PLG_Setup} value="plgSetup">
                        {this.state.activeTab === "plgSetup" &&
                            <div></div>
                        }
                    </Tab>
                    <Tab label={strings.Marketing_Funnel} value="marketing_funnel">
                        {this.state.activeTab === "marketing_funnel" &&
                            <AccountManagerDetailsMarketingFunnelTab />
                        }
                    </Tab>
                    {permissionHelper.hasAccountManagerPermission(AuthenticationStore.AccountManagerUserPermissions.Account.ViewSystemTab) &&
                        <Tab label={strings.System} value="system">
                            {this.state.activeTab === "system" &&
                                <AccountManagerDetailsSystemTab accountManagerId={this.props.accountManagerId} />
                            }
                        </Tab>
                    }
                </Tabs>
            </div>
        )
    }
}